import { Alert, Icons } from '@commenda/kakashi';
import { VALIDATION_MESSAGES } from '../../constants';
import { CoverageGapEntry } from '../../types';

interface CoverageGapAlertProps {
  gaps: CoverageGapEntry[];
}

export function CoverageGapAlert({ gaps }: CoverageGapAlertProps) {
  if (!gaps || gaps.length === 0) return null;

  return (
    <Alert
      variant="warning"
      icon={<Icons.AlertCircle className="size-5 text-text-warning" />}
      title="Skipped filing(s)"
      description={VALIDATION_MESSAGES.COVERAGE_GAP}
    />
  );
}
